import _ from 'lodash';

var allTimelineStatuses = [
    { code : 0, message : "Opened", slug : "opened" },
    { code : 100, message : "Driver is 3 miles from origin", slug : "arriving_at_origin" },
    { code : 200, message : "Arrived at origin", slug : "arrived_at_origin" },
    { code : 300, message : "Picked up shipment", slug : "picked_up_shipment" },
    { code : 600, message : "En route", slug : "en_route" },
    { code : 700, message : "Driver is 3 miles from destination", slug : "arriving_at_destination" },
    { code : 800, message : "Arrived at destination", slug : "arrived_at_destination" },
    { code : 900, message : "Delivered", slug : "delivered" },
    { code : 1000, message : "Received POD", slug : "signed" },
    { code : 1100, message : "BOL Uploaded", slug : "bill_of_lading_uploaded" },
    { code : 1200, message : "Job Canceled", slug : "job_canceled" },
    { code : 1300, message : "Job Closed", slug : "job_closed" }
];

var notSelectableStatuses = ["job_canceled", "job_closed", "bill_of_lading_origin_uploaded", "signed_pickup", "bill_of_lading_uploaded", "signed"];

var getStatusFromSlug = function(slug){
    var result =  _.find(allTimelineStatuses,
        function(it){ return it.slug === slug });
    return result;
}

var selectableTimelineStatuses = _.reject(allTimelineStatuses,
    function(it){
        return _.find(notSelectableStatuses, function(that){ return that === it.slug });
    }
);

export default {
    allTimelineStatuses:selectableTimelineStatuses,
    getStatusFromSlug:getStatusFromSlug
}
